import React, { useContext, useState } from "react";
import Switch from "@mui/material/Switch";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../../Context/AuthContext";
import { UPDATE_MANDATE_STATUS } from "../../../Schema/Mandate";

export default function SwitchStatus({ row, setRefetch }) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);

  const [updateMandateStatus] = useMutation(UPDATE_MANDATE_STATUS, {
    onCompleted: ({ updateMandateStatus }) => {
      setAlert(true, "success", updateMandateStatus?.message);
      setRefetch();
    },
  });

  const handleChange = (event) => {
    const newStatus = event.target.checked;

    updateMandateStatus({
      variables: { id: row?._id, isActive: newStatus },
    });
  };

  return (
    <Switch
      checked={row?.isActive}
      onChange={handleChange}
      slotProps={{ input: { "aria-label": "controlled" } }}
    />
  );
}
